import { render, staticRenderFns } from "./DemoTable.vue?vue&type=template&id=6473befb&"
import script from "./DemoTable.vue?vue&type=script&lang=js&"
export * from "./DemoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports